import { noCoverageField } from '@hb/shared'
import { useMemo } from 'react'
import { InsuranceInfoForm } from './InsuranceInfoForm'
import { useInsuranceInfoStage } from './context'

export const NoCoverage = () => {
  const { insuranceInfoData, onUpdate } = useInsuranceInfoStage()
  const isActive = useMemo(() => insuranceInfoData.option === 'no-coverage', [insuranceInfoData])

  return (
    <InsuranceInfoForm
      field={noCoverageField}
      data={insuranceInfoData}
      onSubmit={onUpdate}
      isActive={isActive}
    />
  )
}
